import { render } from "./UiInfoScreen.vue?vue&type=template&id=7688bc2a"
import script from "./UiInfoScreen.vue?vue&type=script&lang=js"
export * from "./UiInfoScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__